<template>
  <div>
    <div>
      <el-form
        size="small"
        :model="ruleForm"
        :rules="rules"
        :hide-required-asterisk="false"
        ref="ruleForm"
        class="demo-ruleForm"
      >
        <div class="add-box dis-flex">
          <div>
            <div class="title">基本信息</div>

            <el-form-item label="品牌名称" prop="brand">
              <el-input
                :placeholder="rules.brand[0].message"
                v-model="ruleForm.brand"
              ></el-input>
            </el-form-item>
            <el-form-item label="客户名称" prop="name">
              <el-input
                :placeholder="rules.name[0].message"
                v-model="ruleForm.name"
              ></el-input>
            </el-form-item>
            <el-form-item label="报备人" prop="principal">
				<el-input
				disabled
				  :placeholder="rules.principal[0].message"
				  v-model="ruleForm.principal"
				></el-input>
            </el-form-item>
           <!-- <el-form-item label="部门" prop="department">
              <el-select
                style="width: 100%"
                v-model="ruleForm.department"
                placeholder="请选择部门"
              >
                <el-option label="角色一" value="角色1"></el-option>
                <el-option label="角色二" value="角色2"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="行业" prop="industry">
             <!-- <el-input
                :placeholder="rules.industry[0].message"
                v-model="ruleForm.industry"
              ></el-input> -->
			  <el-select
			    style="width: 100%"
			    v-model="ruleForm.industry"
			    placeholder="请选择行业"
			  >
			    <el-option
				  v-for="(item,key) in options2"
				  :key="key"
				  :label="item.name"
				  :value="item.name">
				</el-option>
			  </el-select>
            </el-form-item>
            <el-form-item label="联系人" prop="docking">
              <el-input
                :placeholder="rules.docking[0].message"
                v-model="ruleForm.docking"
              ></el-input>
            </el-form-item>
			<el-form-item label="职位" prop="position">
			  <el-input
			    :placeholder="rules.position[0].message"
			    v-model="ruleForm.position"
			  ></el-input>
			</el-form-item>
            <el-form-item label="联系方式" prop="phone">
              <el-input
                :placeholder="rules.phone[0].message"
                v-model="ruleForm.phone"
              ></el-input>
            </el-form-item>
            <el-form-item label="地址" prop="address">
              <el-input
                :placeholder="rules.address[0].message"
                v-model="ruleForm.address"
              ></el-input>
            </el-form-item>
          </div>
          <div style="margin-left:50px">
            <div class="title">合作信息</div>

            <el-form-item label="备注" prop="remarks">
              <el-input
                :placeholder="rules.remarks[0].message"
                v-model="ruleForm.remarks"
              ></el-input>
            </el-form-item>
			<el-form-item label="跟单情况" prop="track">
			  <el-input
			    :placeholder="rules.track[0].message"
			    v-model="ruleForm.track"
			  ></el-input>
			</el-form-item>
            <el-form-item label="合作情况" prop="status">
              <el-select
                style="width: 100%"
                v-model="ruleForm.status"
                placeholder="请选择合作情况"
              >
                <el-option
				  v-for="(item,key) in options"
				  :key="key"
				  :label="item"
				  :value="key">
				</el-option>
              </el-select>
            </el-form-item>
            
          </div>
        </div>
      </el-form>
    </div>
    <div class="row1">
      <div>
        <el-button
        @click="submitForm('ruleForm')"
        class="row-btn add"
        type="primary"
        size="small"
        >{{type == 1?'提交':'修改'}}</el-button>
      <el-button
        @click="back"
        class="row-btn add back"
        type="primary"
        size="small"
        >返回</el-button
      >
      </div>
      
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
	type:'',//1为添加，2为修改
	options:[],
	options2:[],
      ruleForm: {
        brand: "",
        name: "",
        docking: "",
        phone: "",
        address: "",
        remarks: "",
        principal:"",
        position:"",
        // department:"",
        industry:"",
        status:"",
        track:"",
      },
      rules: {
        brand: [
          { required: true, message: "请输入品牌名称", trigger: ["blur","change"] },
        ],
        name: [
          { required: true, message: "请输入用户名称", trigger: ["blur","change"] },
        ],
        docking: [
          { required: true, message: "请输入联系人", trigger: ["blur","change"] },
        ],
        phone: [
          { required: true, message: "请输入联系方式", trigger: ["blur","change"] },
        ],
        address: [{ required: true, message: "请输入地址", trigger: ["blur","change"] }],
        remarks: [
          { required: true, message: "请输入备注", trigger: ["blur","change"] },
        ],
        principal: [
          { required: true, message: "请输入责任人", trigger: ["blur","change"] },
        ],
        position: [
          { required: true, message: "请输入职位", trigger: ["blur","change"] },
        ],
        // department: [
        //   { required: true, message: "请选择部门", trigger: "change" },
        // ],
        industry: [
          { required: true, message: "请选择行业", trigger: ["change"] },
        ],
        status: [
          { required: true, message: "请选择合作情况", trigger: "change" },
        ],
        track: [
          { required: true, message: "请输入跟单情况", trigger: ["blur","change"] },
        ],
      },
    };
  },
  created() {
	this.type = this.$route.query.type //1为添加，2为修改
	this.ruleForm.principal = JSON.parse(localStorage.getItem('userInfo')).name;
	if(this.$route.query.type == 2){
		for(let key in this.ruleForm){
			this.ruleForm[key] = this.$route.query[key]
		}
		this.ruleForm.id = this.$route.query.id
		this.ruleForm.status = this.$route.query.status.value
	}
	this.reportEnum()
  },
  methods: {
    // 返回
    back(){
      this.$router.go(-1)
    },
	//获取合作情况
	reportEnum(){
		this.$api2.reportEnum().then((res)=>{
			if(res.code == 1){
				this.options = res.data.status
				this.options2 = res.data.industry
			}
		})
	},
    //   提交按钮
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
			//1为添加，2为修改
          if(this.type == 1){
			  this.$api2.addReport(this.ruleForm).then((res)=>{
			  	if(res.code == 1){
			  		this.$message.success(res.msg)
					setTimeout(()=>{
						this.$router.push({ path: "/reportList"});
					},1.5e3)
			  	}else{
			  		this.$message.error(res.msg)
			  	}
			  })
		  }else if(this.type == 2){
			  this.$api2.editReport(this.ruleForm).then((res)=>{
			  	if(res.code == 1){
			  		this.$message.success(res.msg)
					setTimeout(()=>{
						this.$router.push({ path: "/reportList"});
					},1.5e3)
			  	}else{
			  		this.$message.error(res.msg)
			  	}
			  })
		  }
        } else {
          this.$message.error("请输入或选择必填项！");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.row1 {
  padding-top: 20px;
  .add {
    padding: 12px 35px;
  }
  .back{
    background-color: #fff;
    color: gray;
    border: 1px solid #DCDFE6;
  }
}
.add-box /deep/ {
  .title {
    font-weight: bold;
    margin-bottom: 10px;
  }
  .el-input {
    width: 300px;
  }
  .el-form-item {
    padding-left: 0 !important;
  }
  .el-form-item__content {
    margin-left: 75px !important;
  }
  .el-form-item__label {
    height: 30px;
    width: 60px !important;
    text-align: justify;
  }
  .el-form-item__label:after {
    display: inline-block;
    content: "";
    padding-left: 100%;
  }
  .el-form-item {
    padding: 10px 30px;
  }
}
/* 去除验证的红色星号 */
.dis-flex
  /deep/
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: " ";
  width: 0px;
  margin-right: 0px;
}
</style>>
